goog.provide("shadow.js.shim.module$$carbon$icons_react$es$Add$default");
shadow.js.shim.module$$carbon$icons_react$es$Add$default = shadow.js.require(345, {}).default;
